import FingerprintJS from "@fingerprintjs/fingerprintjs";

export type SavedDetails = {
  name: string;
  school: string;
  validity: string;
  birth: string;
  id: string;
};

export type AuditSnapshot = {
  details: SavedDetails;
  image: string | null;
};

export type AuditEventType = "app_opened" | "details_changed";

const fingerprintPromise = FingerprintJS.load().then((agent) => agent.get());

function createEventId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (character) =>
    (Number(character) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(character) / 4)))).toString(16)
  );
}

export async function storeAuditEvent(
  eventType: AuditEventType,
  snapshot: AuditSnapshot,
  eventId = createEventId()
): Promise<void> {
  try {
    const result = await fingerprintPromise;
    const browser = {
      confidence: result.confidence,
      userAgent: navigator.userAgent,
      language: navigator.language,
      languages: navigator.languages,
      platform: navigator.platform,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        colorDepth: window.screen.colorDepth,
        pixelRatio: window.devicePixelRatio,
      },
    };

    const response = await fetch("/api/audit-events", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventId,
        eventType,
        fingerprint: result.visitorId,
        browser,
        details: snapshot.details,
        image: snapshot.image,
        clientTime: new Date().toISOString(),
      }),
    });

    if (!response.ok) throw new Error(`Audit API returned ${response.status}`);
  } catch (error) {
    console.error("Unable to store audit event", error);
  }
}
